<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.supplierName"
              placeholder="请输入供应商名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @submit="submitFun(arguments)"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadCommissionedOrderListDataApi, submitCommissionedOrderApi } from '@/api/materialsCommissionedOrder'

export default {
  name: 'MaterialsCommissionedOrderTodoSubmitList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_commissioned_order_task_submit_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'submit',
            label: '提交',
            method: 'submit'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            supplierName: '',
            supplier: 2, // 当地制作
            status: 1
          }
        }
      },
      isPaging: true,
      typeOptions: [{ value: 1, label: '委托制作' }, { value: 2, label: '购买' }],
      multipleSelection: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'id', label: '单据编号', filterColumn: 'id', width: 105 },
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
          { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 100 },
          { prop: 'supplierName', label: '供应商名称', filterColumn: 'supplier_name', width: 200 },
          { prop: 'typeValue', label: '订单类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 105 },
          { prop: 'orderDateValue', label: '订单日期', filterColumn: 'order_date', width: 120 },
          { prop: 'makeMaterials', label: '物料信息', filterColumn: 'make_materials', width: 400 },
          { prop: 'orderAmount', label: '订单金额', filterColumn: 'order_amount', width: 130, isPrice: true, isBetween: true },
          { prop: 'makeAmount', label: '物料制作金额', filterColumn: 'make_amount', width: 130, isPrice: true, isBetween: true },
          { prop: 'otherAmount', label: '其他费用金额', filterColumn: 'other_amount', width: 130, isPrice: true, isBetween: true },
          { prop: 'otherReason', label: '其他费用说明', filterColumn: 'other_reason', width: 150 },
          { prop: 'manager', label: '经办人', filterColumn: 'manager', width: 100 },
          { prop: 'creator', filterColumn: 'creator', label: '创建人', width: 110 },
          { prop: 'createTimeValue', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort.order = ''
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      loadCommissionedOrderListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 提交
    submitFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要提交的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '物料委托制作单不是制单状态，不能提交', type: 'warning' })
        return
      }
      this.$confirm('是否确定提交该物料委托制作单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        submitCommissionedOrderApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.reloadMasterData()
          }
        })
      }).catch(() => { })
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
